module.exports = __webpack_public_path__ + "img/a30.a47599c3.svg";